var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-gene-lab-order',_vm._g(_vm._b({staticClass:"pt-gene-lab-order__withData",attrs:{"detection-package-list":_vm.detectionPackageList,"areaList":_vm.areaList,"seqTypes":_vm.seqTypes}},'pt-gene-lab-order',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }